<div class="language-selector">
  <ion-item>
    <ion-select 
      [(ngModel)]="currentLanguage"
      (ionChange)="switchLanguage($event.detail.value)" 
      label="Language" 
      label-placement="stacked"
      interface="popover"
      placeholder="Select Language">
      <ion-select-option 
        *ngFor="let lang of availableLanguages" 
        [value]="lang.code">
        {{ lang.name }}
      </ion-select-option>
    </ion-select>
  </ion-item>
</div>
